import { createHistoryRouter, createRoute, createRouterControls } from 'atomic-router';

export const routes = {
  positions: createRoute(),
  position: createRoute<{ id: string }>(),
  alerts: createRoute(),
  stats: createRoute(),
  charts: createRoute(),
  watchlist: createRoute(),
  settings: createRoute(),
  signIn: createRoute(),
  notFound: createRoute(),
};

export const controls = createRouterControls();

export const router = createHistoryRouter({
  routes: [
    { path: '/', route: routes.positions },
    { path: '/positions/:id', route: routes.position },
    { path: '/alerts', route: routes.alerts },
    { path: '/stats', route: routes.stats },
    { path: '/charts', route: routes.charts },
    { path: '/watchlist', route: routes.watchlist },
    { path: '/settings', route: routes.settings },
    { path: '/sign-in', route: routes.signIn },
  ],
  notFoundRoute: routes.notFound,
  controls,
});
